import { ListItemText } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grid from "@material-ui/core/Grid";
import Grow from "@material-ui/core/Grow";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import MenuList from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import Popper from "@material-ui/core/Popper";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { updateAuthentication } from "Actions/AuthenticationAction";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import AssetsIcon from "Assets/newicons/app/assets/outline/assets-outline-16px.svg";
import checklistoutlined from "Assets/newicons/app/checklist/outline/checklist-outline-16px.svg";
import leavesIcon from "Assets/newicons/app/leaves/outline/leaves-outline-16px.svg";
import recruitoutlined from "Assets/newicons/app/recruit/outline/recruit-outline-16px.svg";
import RequestCenterIcon from "Assets/newicons/app/request-center/outline/request-center-outline-16px.svg";
import calendarIcon from "Assets/newicons/app/sumcal/outline/sumcal-outline-16px.svg";
import okroutlined from "Assets/newicons/app/okr/outilne/okr-outline-16px.svg";

import Configs from "Constants/Configs";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Configure,
  connectRefinementList,
  CurrentRefinements,
  Highlight,
  InstantSearch,
} from "react-instantsearch-dom";
import { connect } from "react-redux";
import { Link, NavLink, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { LogMeOut } from "../../../Actions/AuthenticationAction";
import { instance } from "../../../Actions/AxiosInstance";
// import Link from "@material-ui/core/Link";
import {
  GetFeature,
  getFormattedPermissions,
  PushNotificationActive,
  SetAllApps,
  SetDrawerID,
  SetOpenLeftDrawer,
  SetSelection,
} from "../../../Actions/commonAction";
import attendanceIcon from "../../../Assets/Icons/Attendance/attendance-16px.svg";
import ConfigModeIcon from "../../../Assets/Icons/Config/config-16px.svg";
import HelpIcon from "../../../Assets/Icons/Help/help-16px.svg";
import hrisIcon from "../../../Assets/Icons/Hris/hris-16px.svg";
import LogoutIcon from "../../../Assets/Icons/Logout/logout-16px.svg";
import MailIcon from "../../../Assets/Icons/Mail/mail-16px.svg";
import newTab from "../../../Assets/Icons/New-tab/new-tab-16px.svg";
import NotificationSettingsIcon from "../../../Assets/Icons/Notification-bell/notification-16px.svg";
import ChangePasswordIcon from "../../../Assets/Icons/Password/password-16px.svg";
import PoliciesIcon from "../../../Assets/Icons/Policy/policy-16px.svg";
import ProfilePrivacyIcon from "../../../Assets/Icons/Privacy/profile-privacy-16px.svg";
import AccountSettingIcon from "../../../Assets/Icons/Settings/setings-16px.svg";
import DailyActivtiesIcon from "../../../Assets/Icons/to-do.svg";
import EmployeeProfileIcon from "../../../Assets/Icons/User/user-16px.svg";
import NotificationEmpty from "../../../Assets/Images/notification-center-empty.svg";
import driveIcon from "../../../Assets/newicons/app/drive/outline/drive-outline-16px.svg";
import expenseIcon from "../../../Assets/newicons/app/expense/outline/expense-outline-16px.svg";
import hrLettersIcon from "../../../Assets/newicons/app/letterbox/outline/letterbox-outline-16px.svg";
import payollIcon from "../../../Assets/newicons/app/payroll/outline/payroll-outline-16px.svg";
import reload from "../../../Assets/Svg/reload.svg";
import { ErrorMessages, FEATUREKEYS } from "../../../Constants";
import { getFormattedImageLink } from "../../../Utils";
import Autocomplete from "./Autocomplete";
import "./index.scss";

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey:
      Configs.MODE == "DEV"
        ? "B2ZdLqbPAX04kssMJJHcaQzqTDip2WPW"
        : "O7JuOqEGV2moskWwXkAY5opLr1yf5p1N",
    // Be sure to use the search-only-api-key

    nodes: [
      {
        host:
          Configs.MODE == "DEV"
            ? "rzi6k7cu2e38lpgap-1.a1.typesense.net"
            : "5d6ixqcrgfj3412kp-1.a1.typesense.net",
        port: "443",
        protocol: "https",
      },
    ],
  },
  // The following parameters are directly passed to Typesense's search API endpoint.
  //  So you can pass any parameters supported by the search endpoint below.
  //  queryBy is required.
  additionalSearchParameters: {
    // q: "sum",
    queryBy: "fullname,emailid,employeecode,primarymobile",
  },
});

const searchClient = typesenseInstantsearchAdapter.searchClient;
const VirtualRefinementList = connectRefinementList(() => null);

class CommonNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      showmenuitems: false,
      // selectionReducer: this.props.selectionReducer,
      menuopen: false,
      isexpand: false,
      isAppsexpand: false,
      isdatarecived: false,
      setAnchorEl: null,
      openNotifications: false,
      newNotificationList: [],
      currentPost: [],
      yesterdayPost: [],
      isloading: false,
      notificationactive: false,
      startOptions: [
        {
          // navroute: "/app/track/attendance/dashboard",
          navroute: "/app/track/attendance",
          includeroutes: [
            // "/app/track/attendance/dashboard",
            "/app/track/attendance",
            "/app/track/gps",
            "/app/track/biometric",
          ],
          key: FEATUREKEYS.attendance,
          name: "Attendance",
          icon: <img src={attendanceIcon}></img>,
        },
        {
          navroute: "/app/track/leave",
          includeroutes: [
            // "/app/track/leave/dashboard",
            "/app/track/leave",
          ],
          key: FEATUREKEYS.leave,
          name: "Leaves",
          icon: <img src={leavesIcon}></img>,
        },
        {
          navroute: "/app/organise/drive",
          includeroutes: ["/app/organise/drive"],
          key: FEATUREKEYS.companyDrive,
          name: "Drive",
          icon: <img src={driveIcon}></img>,
        },
        {
          navroute: "/app/resolve/checklist",
          includeroutes: ["/app/resolve/checklist"],
          key: FEATUREKEYS.checklist,
          name: "Checklist",
          icon: <img src={checklistoutlined}></img>,
        },

        // {
        //   navroute: "/assets",
        //   includeroutes: ["/assets"],
        //   key: FEATUREKEYS.asset,
        //   name: "Asset",
        //   icon: <img src={AssetsIcon}></img>,
        // },
        // {
        //   navroute: "/app/recruit/pipeline",
        //   includeroutes: [
        //     "/app/recruit/pipeline",
        //     // "/app/recruit/pipeline/:id",
        //     // "/app/recruit/pipeline/:id/:candidate_id",
        //     "/app/recruit/talent_pool",
        //     "/app/recruit/hiring_plan",
        //     "/app/recruit/requisition",
        //   ],
        //   key: FEATUREKEYS.recruit,
        //   name: "Recruit",
        //   icon: <img src={recruitoutlined}></img>,
        // },

        // {
        //   navroute: "/app/organise/letters",
        //   includeroutes: ["/app/organise/letters"],
        //   key: FEATUREKEYS.letters,
        //   name: "Letters",
        //   icon: <img src={hrLettersIcon}></img>,
        // },
      ],
      ConstantsEntityid: [
        { name: "RequestCenter", key: 1, icon: MailIcon },
        { name: "Employee Profile", key: 2, icon: EmployeeProfileIcon },
        { name: "Policies", key: 3, icon: PoliciesIcon },
        { name: "Daily Activites", key: 4, icon: DailyActivtiesIcon },
      ],
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onNotificationAction = this.onNotificationAction.bind(this);
    this.onNotificationShow = this.onNotificationShow.bind(this);
    this.activeElement = this.activeElement.bind(this);
    this.expandMenu = this.expandMenu.bind(this);
    this.logout = this.logout.bind(this);
    this.openNotifications = this.openNotifications.bind(this);
    this.sortPost = this.sortPost.bind(this);
    this.clearNotification = this.clearNotification.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.setOption = this.setOption.bind(this);
    this.syncapp = this.syncapp.bind(this);
    this.updateDrawer = this.updateDrawer.bind(this);
    this.getCommonConfig = this.getCommonConfig.bind(this);
  }

  onNotificationAction(data) {
    localStorage.setItem("isnavigation", "yes");
    // localStorage.setItem("requestcode", data.requestcode);
    // /XPWYhj2/2
    // const employeeLink = `${window.location.origin}/request_center/:${data.requestcode}/:${data.actionid}`;
    let employeeLink;
    if (data.entityid == 12) {
      if (data.identifierdata.notificationtypeid == 1) {
        employeeLink = `${window.location.origin}/app/helpdesk/${data.identifierdata.ticketid}`;
      } else if (data.identifierdata.notificationtypeid == 2) {
        if (data.identifierdata.isself) {
          employeeLink = `${window.location.origin}/helpdesk/${data.identifierdata.ticketid}`;
        } else {
          employeeLink = `${window.location.origin}/app/helpdesk/${data.identifierdata.ticketid}`;
        }
      } else if (data.identifierdata.notificationtypeid == 3) {
        employeeLink = `${window.location.origin}/helpdesk/${data.identifierdata.ticketid}`;
      }
    } else {
      employeeLink = `${window.location.origin}/request_center/notification/${data.requestcode}/100`;
    }

    window.open(employeeLink, "_blank");
  }

  onNotificationShow(data) {
    // localStorage.setItem("isnavigation", "yes");
    // localStorage.setItem("requestcode", data.requestcode);
    // // /XPWYhj2/2
    // // const employeeLink = `${window.location.origin}/request_center/:${data.requestcode}/:${data.actionid}`;
    // const employeeLink = `${window.location.origin}/notification_center`;
    // window.open(employeeLink, "_blank");
  }

  componentWillMount() {
    document.addEventListener("mouseleave", this.handleClick1, false);
  }

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  componentWillUnmount() {
    document.removeEventListener("mouseleave", this.handleClick1, false);
  }

  onSuggestionSelected = (_, { suggestion }) => {
    this.setState({
      query: suggestion.fullname,
    });
  };

  onSuggestionCleared = () => {
    this.setState({
      query: "",
    });
  };

  handleClick1 = (e) => {
    if (this.node && this.node.contains(e.target)) {
      this.setState({
        menuopen: true,
      });
    }
    this.handleClickOutside();
  };

  updateDrawer(key) {
    this.props.SetOpenLeftDrawer(true);
    // this.props.SetAllApps(false);
    this.props.SetDrawerID(key);
    // this.setState({
    //   navPopper: false,
    // });
  }

  handleClickOutside = (e) => {
    this.setState({
      menuopen: false,
    });
  };

  componentDidMount() {
    // console.log("start", this.state);
    // const appversion = window.localStorage.getItem("appversion");
    
    this.getCommonConfig();
    const features = get(this.props, "AuthenticationAction.login.features", "");
    const masterprofileid = get(
      this.props,
      "AuthenticationAction.login.masterprofileid",
      "",
    );
    const x = this.state.startOptions.filter((opt) => {
      const index = features.findIndex(
        (ftr) => opt.key === ftr.featureid && ftr.hasAppAccess,
      );
      if (index != -1) {
        return opt;
      }
      return false;
    });

    const expense = GetFeature("employeeExpense");
    const compensator = GetFeature("adminDashboard");
    let expenseaccess = false;
    let compaccess = false;
    if (expense) {
      expenseaccess = expense && expense.hasAppAccess;
    }
    if (compensator) {
      compaccess = compensator && compensator.hasAppAccess;
    }
    // Temporary remove this
    // x.push({
    //   navroute: "/assets",
    //   includeroutes: ["/assets"],
    //   key: FEATUREKEYS.assets,
    //   name: "Assets",
    //   icon: <img src={AssetsIcon}></img>,
    // });
    // ---END
    if (expenseaccess || compaccess) {
      x.push({
        navroute: "/app/pay/expense",
        includeroutes: ["/app/pay/expense", "/app/pay/expense/compensator"],
        key: FEATUREKEYS.employeeExpense,
        name: "Expense",
        icon: <img src={expenseIcon}></img>,
      });
    }
    if (masterprofileid == 9) {
      const obj = {
        navroute: "/app/hris/dashboard",
        includeroutes: ["/app/hris/dashboard"],
        key: "010101",
        name: "HRIS",
        icon: <img src={hrisIcon}></img>,
        menuopen: false,
      };
      x.unshift(obj);
    }

    // if (masterprofileid == 8 || masterprofileid == 9) {
    //   const obj = {
    //     navroute: "/dashboard",
    //     includeroutes: ["/dashboard"],
    //     key: "",
    //     name: "Dashboards",
    //     icon: <img src={dashboardIcon}></img>,
    //     menuopen: false,
    //   };
    //   x.unshift(obj);
    // }

    masterprofileid == 9 &&
      GetFeature("letters") &&
      x.push({
        navroute: "/app/organise/letter/new",
        includeroutes: [
          "/app/organise/letter",
          "/app/organise/letter/new",
          "/app/organise/letter/draft",
          "/app/organise/letter/sent",
          "/app/organise/letter/post_office",
        ],
        key: FEATUREKEYS.letters,
        name: "Letters",
        icon: <img src={hrLettersIcon}></img>,
      });

    (masterprofileid == 9 || this.props.isticketowner) &&
      x.push({
        navroute: "/app/helpdesk",
        includeroutes: [],
        key: FEATUREKEYS.helpdesk,
        name: "Helpdesk",
        icon: <img src={HelpIcon}></img>,
      });

    GetFeature("assetAssignment") &&
      x.push({
        navroute: "/app/hrops/assets",
        includeroutes: [
          // "/app/organise/letter",
          // "/app/organise/letter/new",
          // "/app/organise/letter/draft",
          // "/app/organise/letter/sent",
          // "/app/organise/letter/post_office",
        ],
        key: FEATUREKEYS.asset,
        name: "Asset",
        icon: <img src={AssetsIcon}></img>,
      });

    (this.props.ishiringmanager ||
      this.props.ishiringowner ||
      this.props.isrecruiter ||
      this.props.isparticipant) &&
      GetFeature("recruit") &&
      x.push({
        navroute: "/app/recruit/pipeline",
        includeroutes: [
          "/app/recruit",
          "/app/recruit/pipeline",

          // "/app/recruit/pipeline/:id",
          // "/app/recruit/pipeline/:id/:candidate_id",
          "/app/recruit/talent_pool",
          "/app/recruit/hiring_plan",
          "/app/recruit/hiring_plan/create",
          "/app/recruit/requisition",
        ],
        key: FEATUREKEYS.recruit,
        name: "Recruit",
        icon: <img src={recruitoutlined}></img>,
      });

    GetFeature("payroll") &&
      (GetFeature("payrolldashboard") ||
        GetFeature("runpayroll") ||
        GetFeature("variable") ||
        GetFeature("appsalaryadvance") ||
        GetFeature("apploan") ||
        GetFeature("appextrapayment") ||
        GetFeature("appextradeduction") ||
        GetFeature("exception") ||
        GetFeature("employeepayroll")) &&
      x.push({
        navroute: "/app/pay/payroll",
        includeroutes: [
          "/app/pay/payroll",
          "/app/pay/payroll/employee/",
          "/app/pay/payroll/dashboard",
          "/app/pay/payroll/variable_payments",
          "/app/pay/payroll/salary_advances",
          "/app/pay/payroll/loans",
          "/app/pay/payroll/extra_payments",
          "/app/pay/payroll/extra_deductions",
          "/app/pay/payroll/exceptions",
          // "/app/pay/payroll/employee/",
        ],
        key: FEATUREKEYS.runPayroll,
        name: "Payroll",
        icon: <img src={payollIcon}></img>,
      });

    const degree = GetFeature("degree");
    if (
      (degree && degree.hasAppAccess) ||
      GetFeature("managefrom") ||
      GetFeature("employeereview")
    ) {
      x.push({
        navroute: GetFeature("managefrom")
          ? "/app/perform/360/form"
          : "/app/perform/360/employee",
        includeroutes: ["/app/perform/360/form", "/app/perform/360/employee"],
        key: FEATUREKEYS.degree,
        name: "Perform",
        icon: <img src={hrLettersIcon}></img>,
      });
    }

    // degree &&
    //   degree.hasAppAccess &&
    //   (GetFeature("managefrom") || GetFeature("employeereview")) &&
    //   x.push({
    //     navroute: "/app/perform/360/form",
    //     includeroutes: ["/app/perform/360/form", "/app/perform/360/employee"],
    //     key: FEATUREKEYS.degree,
    //     name: "Perform",
    //     icon: <img src={hrLettersIcon}></img>,
    //   });

    degree &&
      GetFeature("okradmin") &&
      x.push({
        navroute: "/app/perform/okr",
        includeroutes: [],
        key: FEATUREKEYS.okradmin,
        name: "OKR & Goals",
        icon: <img src={okroutlined}></img>,
      });

    this.setState({
      startOptions: x,
    });
  }

  getCommonConfig() {
    instance
      .get("subscription/getcommonconfig")
      .then((result) => {
        this.setState({
          iscaldepartment: result.data.result[0]
            ? result.data.result[0].iscaldepartment
            : true,
          iscalorganization: result.data.result[0]
            ? result.data.result[0].iscalorganization
            : false,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  logout() {
    this.props.enqueueSnackbar(ErrorMessages.E0090, {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          key="key"
          onClick={() =>
            this.props.LogMeOut(
              get(this.props, "AuthenticationAction.login.userid", ""),
            )
          }
        >
          Yes
        </Button>,
        <Button
          color="inherit"
          size="small"
          key="key"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  handleClick(event, el) {
    if (el == "notifications") {
      this.setState({
        setAnchorEl: event.currentTarget,
        openNotifications: !this.state.openNotifications,
        menuopen: false,
      });
      this.getAllnotifications();
    } else {
      this.setState(
        {
          setAnchorEl: event.currentTarget,
          menuopen: false,
        },
        () => {
          this.setState({
            isexpand: true,
            menuopen: false,
          });
        },
      );
    }
  }

  handleClose() {
    console.log("notification");
    this.setState({
      isexpand: false,
      openNotifications: false,
      notificationactive: false,
    });
  }

  activeElement(id) {
    this.props.SetDrawerID(id);
    this.props.SetOpenLeftDrawer(false);
  }

  setOption() {
    this.props.SetOpenLeftDrawer(false);
    this.props.SetDrawerID(0);
    this.setState({ menuopen: false });
  }

  async syncapp() {
    const { AuthenticationAction } = this.props;
    const hardrefreshapp = () => {
      if (caches) {
        caches.keys().then((keys) => {
          for (const key of keys) caches.delete(key);
        });
      }
      window.location.reload(true);
    };
    try {
      const permissionsresult = await instance.get(
        "subscription/getuserpermssion",
      );
      const plans = await instance.post(`superuser/getcompanyplanconfig`, {
        accountid:
          AuthenticationAction.login && AuthenticationAction.login.accountid,
        subscriptionid:
          AuthenticationAction.login &&
          AuthenticationAction.login.subscriptionid,
      });
      const objsuportplan = plans.data.result[0]
        ? plans.data.result.find((x) => x.typeid == 1)
        : null;
      const objpriceplan = plans.data.result[0]
        ? plans.data.result.find((x) => x.typeid == 2)
        : null;
      let logindata = {
        ...AuthenticationAction.login,
        objsuportplan,
        objpriceplan,
      };
      const migrationlist = await instance.get(
        "superuser/getconfigmigrationinit",
      );
      logindata.migration = migrationlist.data.result;
      logindata.features = getFormattedPermissions(
        permissionsresult.data.result,
      );

      const isAdmin = logindata.masterprofileid >= 9;

      let hasAttendanceAppAccess = isAdmin;
      let hasLeaveAppAccess = isAdmin;
      let hasExpenseAppAccess = isAdmin;
      let hasPerformAppAccess = isAdmin;
      let hasCompensatorAccess = isAdmin;
      const hasDriveAccess = isAdmin;
      const hasLetterAccess = isAdmin;
      // const hasRecruitAppAccess =
      //   this.props.isrecruiter ||
      //   this.props.ishiringowner ||
      //   this.props.ishiringmanager ||
      //   this.props.isparticipant;
      const hasRecruitAppAccess = true;

      if (!isAdmin) {
        try {
          let data = {
            featurekey: "attendanceLogs",
            workflowfortypeid: 2,
          };
          const attendanceapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasAttendanceAppAccess =
          //   isAdmin || get(attendanceapproverreportee, "data.result[0]", "");

          hasAttendanceAppAccess = get(
            attendanceapproverreportee,
            "data.result[0]",
            "",
          );

          data = {
            featurekey: "leaveBalanceAndHistory",
            workflowfortypeid: 3,
          };
          const leaveapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasLeaveAppAccess =
          //   isAdmin || get(leaveapproverreportee, "data.result[0]", "");

          hasLeaveAppAccess = get(leaveapproverreportee, "data.result[0]", "");
          data = {
            featurekey: "employeeExpense",
            workflowfortypeid: 5,
          };
          const expenseapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasExpenseAppAccess =
          //   isAdmin || get(expenseapproverreportee, "data.result[0]", "");

          hasExpenseAppAccess = get(
            expenseapproverreportee,
            "data.result[0]",
            "",
          );

          const checkiscompensator = await instance.get(
            `expense/checkiscompensator`,
          );
          // hasCompensatorAccess =
          //   isAdmin ||
          //   get(checkiscompensator, "data.result[0].iscompensator", "");

          hasCompensatorAccess = get(
            checkiscompensator,
            "data.result[0].iscompensator",
            "",
          );

          data = {
            featurekey: "degree",
            workflowfortypeid: 6,
          };
          const performapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasPerformAppAccess =
          //   isAdmin || get(performapproverreportee, "data.result[0]", "");
          hasPerformAppAccess = isAdmin;
        } catch (err) {
          this.props.enqueueSnackbar(
            get(
              err,
              "responses.data.error.message",
              "Please check username and password",
            ),
            { variant: "error" },
          );
          this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
            IsFulfilled: true,
            data: null,
          });
          return false;
        }
      }

      if (hasCompensatorAccess) {
        get(logindata, "features", []).push({
          hasAppAccess: true,
          permissions: {
            readOnly: false,
            editable: true,
          },
          featureid: 314,
        });
      }

      logindata = {
        ...logindata,
        features: get(logindata, "features", []).map((feature) => {
          const res = feature;
          if (feature.featureid == FEATUREKEYS.attendance) {
            res.hasAppAccess = hasAttendanceAppAccess;
          } else if (feature.featureid == FEATUREKEYS.leave) {
            res.hasAppAccess = hasLeaveAppAccess;
          } else if (feature.featureid == FEATUREKEYS.employeeExpense) {
            res.hasAppAccess = hasExpenseAppAccess;
          } else if (feature.featureid == FEATUREKEYS.adminDashboard) {
            res.hasAppAccess = hasCompensatorAccess;
          } else if (feature.featureid == FEATUREKEYS.companyDrive) {
            res.hasAppAccess = hasDriveAccess;
          } else if (feature.featureid == FEATUREKEYS.letters) {
            res.hasAppAccess = hasLetterAccess;
          } else if (feature.featureid == FEATUREKEYS.degree) {
            res.hasAppAccess = hasPerformAppAccess;
          }
          // else if (feature.featureid == FEATUREKEYS.recruit) {
          //   res.hasAppAccess = hasRecruitAppAccess;
          // }
          return res;
        }),
      };

      this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
        IsFulfilled: true,
        data: logindata,
      });
      this.setState({ anchorEl: null, isexpand: false });
      hardrefreshapp();
    } catch (e) {
      this.setState({ anchorEl: null, isexpand: false });
      this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
        IsFulfilled: true,
        data: null,
      });
    }
  }

  expandMenu() {
    this.props.SetAllApps(true);
    this.setState({
      isAppsexpand: !this.state.isAppsexpand,
      isleftDrawerOpen: false,
    });
  }

  openNotifications() {
    this.setState({ openNotifications: true });
  }

  sortPost() {
    const currentPost = [];
    const yesterdayPost = [];
    this.state.newNotificationList.forEach((item) => {
      if (moment(item.notifiedon).isSame(moment(), "day")) {
        currentPost.push(item);
      } else {
        yesterdayPost.push(item);
      }
    });
    this.setState({ currentPost, yesterdayPost });
  }

  clearNotification() {
    this.setState({
      currentPost: [],
      yesterdayPost: [],
      newNotificationList: [],
    });
  }

  getAllnotifications() {
    this.setState({ isloading: true }, () => {
      const offset = 0;
      const limit = 10;
      const { employeeid } = this.props.AuthenticationAction.login;
      instance
        .get(`subscription/notificationlist/${offset}/${limit}/${employeeid}`)
        .then((result) => {
          instance.put(`subscription/readnotification`).then(() => {});
          this.props.setNotification();
          this.setState({
            notificationactive: !this.state.notificationactive,
            newNotificationList: result.data.result,
            isdatarecived: true,
            isloading: false,
          });
          this.props.PushNotificationActive(false);
          this.sortPost();
        })
        .catch((result) => {
          console.error(get(result, "error.msg", ""));
          this.setState({
            isloading: false,
          });
        });
    });
  }

  onMenuClick() {
    this.setState({
      menuopen: true,
    });
  }

  onClickAway() {
    this.setState({
      menuopen: false,
    });
  }

  render() {
    const masterprofileid = get(
      this.props,
      "AuthenticationAction.login.masterprofileid",
      "",
    );
    // const isOwner = masterprofileid == 10 || masterprofileid == 11;
    const configfeature = get(
      this.props,
      "AuthenticationAction.login.features",
      [],
    ).find((feature) => parseInt(feature.featureid) > 999);
    const isAdmin = configfeature;
    const isOwner = get(this.props, "AuthenticationAction.login.isowner", null);
    const { startOptions } = this.state;
    const selectedOption = startOptions.find(
      (x) =>
        x.includeroutes.findIndex((y) => y == window.location.pathname) != -1,
    );

    return (
      <div className="navbar-main">
        {this.props.selectionReducer.appMode != "config" &&
          GetFeature("directory") && (
            <InstantSearch
              indexName="employeeprofile"
              searchClient={searchClient}
            >
              <div className="universal-search-container">
                <Autocomplete
                  onSuggestionSelected={this.onSuggestionSelected}
                  onSuggestionCleared={this.onSuggestionCleared}
                  masterprofileid={masterprofileid}
                />
                <Configure
                  facetFilters={[
                    `accountid:${this.props.SubscriptionInfo.SubscriptionData.accountid}`,
                    `subscriptionid:${this.props.SubscriptionInfo.SubscriptionData.subscriptionid}`,
                  ]}
                />
                <CurrentRefinements />
              </div>
            </InstantSearch>
          )}

        <AppBar
        // position="static"
        >
          <Toolbar className="navbar-toolbar">
            <div className="top-nav-log-wrapper">
              <img
                src={getFormattedImageLink(
                  get(this.props, "SubscriptionInfo.SubscriptionData.logo", ""),
                )}
                className="top-nav-logo"
                color="inherit"
                aria-label="CompanyLogo"
              />
            </div>
            {this.props.selectionReducer.appMode != "config" &&
              get(this.state, "startOptions", []).length !== 0 &&
              (this.props.selectionReducer.isallappsopen ? (
                /* {this.state.isAppsexpand ? ( */
                <div className="navbar-list-item">
                  <List className="navbar-list-item-ul">
                    <ListItem className="navbar-list-item-li">
                      <NavLink to="/app/track/attendance/logs">
                        <span
                          className={
                            this.props.selectionReducer.selectedDrawerId ==
                            FEATUREKEYS.track
                              ? "navbar-list-item-li-span nav-footer-list-item-active"
                              : "navbar-list-item-li-span nav-footer-list-item"
                          }
                          onClick={() => this.activeElement(FEATUREKEYS.track)}
                        >
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill=""
                                fillRule="evenodd"
                                d="M8 0a7.95 7.95 0 0 0-3.149.649l.582.582c.12.12.225.253.317.393A6.72 6.72 0 0 1 8 1.23 6.777 6.777 0 0 1 14.77 8 6.777 6.777 0 0 1 8 14.77 6.777 6.777 0 0 1 1.23 8c0-.79.144-1.544.394-2.249a2.447 2.447 0 0 1-.393-.318L.649 4.85A7.95 7.95 0 0 0 0 8c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8zM1.225.61a.615.615 0 0 0-.43 1.056l.796.796h-.536c-.39 0-.584.47-.309.746l1.355 1.354c.23.231.544.361.87.361h1.082l3.512 3.512a.615.615 0 1 0 .87-.87L4.923 4.053V2.97c0-.326-.13-.64-.36-.87L3.208.746a.437.437 0 0 0-.746.31v.535L1.666.796a.615.615 0 0 0-.441-.187zM8 2.461c-.655 0-1.28.119-1.864.329.005.06.018.12.018.18v.572l.402.403A4.289 4.289 0 0 1 8 3.692 4.313 4.313 0 0 1 12.308 8 4.313 4.313 0 0 1 8 12.308 4.313 4.313 0 0 1 3.692 8c0-.506.092-.991.254-1.444l-.403-.402h-.572c-.06 0-.12-.013-.18-.018-.21.583-.33 1.21-.33 1.864A5.545 5.545 0 0 0 8 13.538 5.545 5.545 0 0 0 13.538 8 5.545 5.545 0 0 0 8 2.462zm0 2.461c-.145 0-.283.024-.423.043l1.728 1.729c.334.335.541.796.541 1.305A1.848 1.848 0 0 1 8 9.846c-.509 0-.97-.207-1.304-.542l-.001.001-1.729-1.728c-.02.14-.043.278-.043.423A3.08 3.08 0 0 0 8 11.077 3.08 3.08 0 0 0 11.077 8 3.08 3.08 0 0 0 8 4.923z"
                              />
                            </svg>
                          </span>
                          <br />
                          <span className="navbar-list-item-li-text">
                            Track
                          </span>
                        </span>
                      </NavLink>
                    </ListItem>
                  </List>
                </div>
              ) : (
                <div className="navbar-list-item position-rel">
                  <List
                    className="navbar-list-item-ul"
                    buttonRef={(node1) => {
                      this.anchorEl = node1;
                    }}
                    onClick={this.onMenuClick}
                  >
                    <ListItem>
                      {/* <NavLink> */}
                      <span className="navbar-list-item-li-span nav-footer-list-item">
                        <span>
                          <svg
                            style={{ position: "relative", top: 3 }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill="#166ab3"
                              fillRule="evenodd"
                              d="M3 0h4v7H0V3a3 3 0 0 1 3-3zM0 9h7v7H3a3 3 0 0 1-3-3V9zm12 0h1v3h3v1h-3v3h-1v-3H9v-1h3V9zM9 0h4a3 3 0 0 1 3 3v4H9V0z"
                            />
                          </svg>
                        </span>
                        {/* <br /> */}
                        <span
                          // className="navbar-list-item-li-text"
                          style={{
                            color: "#166ab3",
                            marginLeft: 8,
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          {get(selectedOption, "name", "Manage")}
                        </span>
                        <span>
                          {this.state.menuopen == true ? (
                            <svg
                              onClick={this.onClickAway}
                              style={{ width: 8, height: 8, marginLeft: 8 }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill="#82bdff"
                                fillRule="evenodd"
                                d="M15.837 13.825c-.243.44-.717.715-1.238.715H1.4c-.521 0-.995-.274-1.238-.715a1.28 1.28 0 0 1 .042-1.32l6.599-10.41A1.4 1.4 0 0 1 8 1.45c.494 0 .941.24 1.197.644l6.599 10.41c.256.407.272.9.041 1.32z"
                                opacity=".35"
                              />
                            </svg>
                          ) : (
                            <svg
                              onClick={this.onClickAway}
                              style={{ width: 8, height: 8, marginLeft: 8 }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill="#82bdff"
                                fillRule="evenodd"
                                d="M15.837 2.165A1.406 1.406 0 0 0 14.6 1.45H1.4c-.521 0-.995.274-1.238.715a1.28 1.28 0 0 0 .042 1.32l6.599 10.41A1.4 1.4 0 0 0 8 14.54c.494 0 .941-.24 1.197-.645l6.599-10.41c.256-.406.272-.9.041-1.32z"
                                opacity=".35"
                              />
                            </svg>
                          )}
                        </span>
                      </span>
                      {/* </NavLink> */}
                    </ListItem>
                  </List>

                  <Popper
                    open={this.state.menuopen}
                    anchorEl={this.anchorEl}
                    placement="right"
                    transition
                    disablePortal
                    style={{
                      zIndex: 1111,
                      width: 220,
                      position: "absolute",
                      top: 70,
                      left: 20,
                    }}
                    className="biometric-poper"
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom"
                              ? "right top"
                              : "right bottom",
                        }}
                      >
                        <Paper ref={(node) => (this.node = node)}>
                          <ClickAwayListener onClickAway={this.onClickAway}>
                            <Grid container>
                              {this.state.startOptions.map((opt) => (
                                <Grid item xs={12} md={6} sm={12} key="key">
                                  <NavLink
                                    onClick={() => this.setOption()}
                                    to={opt.navroute}
                                  >
                                    <div className="padding8">
                                      <div className="apps-thumbnail-wrapper">
                                        <span className="display-block text-center">
                                          {opt.icon}
                                        </span>
                                        <span className="apps-thumbnail">
                                          {opt.name}
                                        </span>
                                      </div>
                                    </div>
                                  </NavLink>
                                </Grid>
                              ))}
                            </Grid>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </div>
              ))}
            <div className="subitems">
              {/* <span
                className="navbar-notification display-block"
                onClick={() =>
                  window.faqbotStartTraining(
                    masterprofileid != 7
                      ? parseInt(9)
                      : parseInt(masterprofileid),
                  )
                }
              >
                <img src={documentIcon} />
              </span> */}

              {(this.state.iscaldepartment ||
                this.state.iscalorganization ||
                masterprofileid == 9) &&
                this.props.selectionReducer.appMode != "config" && (
                  <NavLink
                    to="/calendar"
                    onClick={() => {
                      this.updateDrawer("calendar");
                      localStorage.removeItem("fromhome");
                    }}
                    style={{ width: 32, marginRight: 16 }}
                  >
                    <Tooltip title="Calendar" placement="top">
                      <span
                        className="navbar-notification display-block cursor-pointer"
                        style={
                          this.props.selectionReducer.selectedDrawerId ==
                          "calendar"
                            ? { border: "2px solid #1e8ced" }
                            : { border: "2px solid #f7f8f8" }
                        }
                      >
                        <img src={calendarIcon} className="vertical-center" />
                      </span>
                    </Tooltip>
                  </NavLink>
                )}
              {this.props.selectionReducer.appMode != "config" && (
                <NavLink
                  to="/request_center"
                  onClick={() => this.updateDrawer("requestcenter")}
                  style={{ width: 32, marginRight: 16 }}
                >
                  <Tooltip title="Request center" placement="top">
                    <span
                      className="navbar-notification display-block"
                      style={
                        this.props.selectionReducer.selectedDrawerId ==
                        "requestcenter"
                          ? { border: "2px solid #1e8ced" }
                          : { border: "2px solid #f7f8f8" }
                      }
                    >
                      <img
                        src={RequestCenterIcon}
                        className="vertical-center"
                      />
                    </span>
                  </Tooltip>
                </NavLink>
              )}

              {this.props.selectionReducer.appMode != "config" && (
                <span
                  className="navbar-notification"
                  onClick={(e) => {
                    this.handleClick(e, "notifications");
                    // this.updateDrawer("notification"); removed as notification is not an one of the menu item
                  }}
                >
                  <img
                    src={NotificationSettingsIcon}
                    className="vertical-center"
                  ></img>
                  {this.props.notificationcount > 0 ? (
                    <span className="navbar-notification-active-dot" />
                  ) : null}
                </span>
              )}
              {/* NOTIFICATION IN TOP NAVBAR  */}
              {this.state.openNotifications ? (
                <Popover
                  className="popper-menu-main notification-popover"
                  open={this.state.openNotifications}
                  anchorEl={this.state.setAnchorEl}
                  onClose={this.handleClose}
                >
                  {this.state.isloading ? (
                    <Paper className="notification-menu-list">
                      {this.showLoader()}
                    </Paper>
                  ) : (
                    <>
                      {this.state.newNotificationList.length > 0 ? (
                        <Paper className="notification-menu-list">
                          <List
                            className="notification-ul"
                            style={{
                              paddingBottom: 0,
                              height: 430,
                              overflowY: "scroll",
                              scrollBehavior: "smooth",
                              padding: 16,
                            }}
                          >
                            <div className="popper-menu-border-div" />
                            {this.state.currentPost.length > 0 ? (
                              <span className="notification-header">Today</span>
                            ) : null}

                            {/* Todays Post Section */}
                            {this.state.currentPost.map((item) => (
                              <ListItem
                                key="key"
                                // className="notification-item cursor-pointer"
                                className={
                                  (item.entityid == 1 && item.requestcode) ||
                                  item.entityid == 12
                                    ? "notification-item cursor-pointer"
                                    : "notification-item"
                                }
                                style={
                                  this.state.currentPost.length > 1
                                    ? { borderBottom: " dashed 1px #f7f8f8" }
                                    : {}
                                }
                                // onClick={
                                //  (item.entityid == 1 && item.requestcode)
                                //     ? () => this.onNotificationAction(item)
                                //     : () => this.onNotificationShow()
                                // }
                              >
                                {this.state.ConstantsEntityid.map((icons) => {
                                  if (item.entityid == icons.key) {
                                    return (
                                      <ListItemIcon
                                        className="notification-ul-icon"
                                        style={{ marginRight: 0 }}
                                      >
                                        <img
                                          src={icons.icon}
                                          style={{ height: 16, marginTop: 8 }}
                                        />
                                      </ListItemIcon>
                                    );
                                  }
                                  return null;
                                })}
                                <ListItemText
                                  secondary={`${get(item, "message.body", "")}${
                                    item.entityid == 1 &&
                                    item.message &&
                                    item.message.requeststatus
                                      ? `[${
                                          item.message.requeststatus[0].toUpperCase() +
                                          item.message.requeststatus.slice(1)
                                        }]`
                                      : ``
                                  }
                                  `}
                                />
                                {((item.entityid == 1 &&
                                  item.requestcode &&
                                  !(item.message.isaditional && true)) ||
                                  item.entityid == 12) && (
                                  <ListItemIcon
                                    className="arrowIconsvg"
                                    onClick={() =>
                                      this.onNotificationAction(item)
                                    }
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="8"
                                      viewBox="0 0 8 8"
                                    >
                                      <path
                                        fill="#FFF"
                                        fillRule="evenodd"
                                        d="M.019 3.581h6.425L3.53.67l.575-.575 3.6 3.6.275.287-.275.288-3.6 3.6-.575-.575L6.444 4.38H.019z"
                                      />
                                    </svg>
                                  </ListItemIcon>
                                )}
                              </ListItem>
                            ))}

                            {/* YesterDays Post */}
                            {this.state.yesterdayPost.length > 0 ? (
                              <span className="notification-header">
                                Yesterday
                              </span>
                            ) : null}

                            {/* <CommonNotificationList
                        arraytobelooped={this.state.yesterdayPost}
                       /> */}
                            {this.state.yesterdayPost.map((item) => (
                              <ListItem
                                key="key"
                                // className="notification-item cursor-pointer"
                                className={
                                  (item.entityid == 1 && item.requestcode) ||
                                  item.entityid == 12
                                    ? "notification-item cursor-pointer"
                                    : "notification-item"
                                }
                                style={
                                  this.state.currentPost.length > 1
                                    ? { borderBottom: " dashed 1px #f7f8f8" }
                                    : {}
                                }
                                // onClick={
                                //   item.entityid == 1 && item.requestcode
                                //     ? () => this.onNotificationAction(item)
                                //     : () => this.onNotificationShow()
                                // }
                              >
                                {this.state.ConstantsEntityid.map((icons) => {
                                  if (item.entityid == icons.key) {
                                    return (
                                      <div>
                                        <ListItemIcon
                                          className="notification-ul-icon"
                                          style={{ marginRight: 0 }}
                                        >
                                          <img
                                            src={icons.icon}
                                            style={{ height: 16, marginTop: 8 }}
                                          />
                                        </ListItemIcon>
                                      </div>
                                    );
                                  }
                                  return null;
                                })}

                                <ListItemText
                                  secondary={`${get(item, "message.body", "")}${
                                    item.entityid == 1 &&
                                    item.message &&
                                    item.message.requeststatus
                                      ? `[${
                                          item.message.requeststatus[0].toUpperCase() +
                                          item.message.requeststatus.slice(1)
                                        }]`
                                      : ``
                                  }
                                  `}
                                />
                                {((item.entityid == 1 &&
                                  item.requestcode &&
                                  !(item.message.isaditional && true)) ||
                                  item.entityid == 12) && (
                                  <ListItemIcon
                                    className="arrowIconsvg"
                                    onClick={() =>
                                      this.onNotificationAction(item)
                                    }
                                  >
                                    {/* <Link to="./request_center"> */}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="8"
                                      viewBox="0 0 8 8"
                                    >
                                      <path
                                        fill="#FFF"
                                        fillRule="evenodd"
                                        d="M.019 3.581h6.425L3.53.67l.575-.575 3.6 3.6.275.287-.275.288-3.6 3.6-.575-.575L6.444 4.38H.019z"
                                      />
                                    </svg>
                                    {/* </Link> */}
                                  </ListItemIcon>
                                )}
                              </ListItem>
                            ))}
                          </List>
                          <ListItem className="menu-bottom-list-items">
                            <ListItemText>
                              <span onClick={this.handleClose} className="t-14">
                                <NavLink to="/notification_center">
                                  View All
                                </NavLink>
                              </span>
                            </ListItemText>
                          </ListItem>
                        </Paper>
                      ) : (
                        <Paper className="notification-menu-list">
                          <div className="notification-empty">
                            <img src={NotificationEmpty} />
                            <span className="main-header">
                              Nothing to show !
                            </span>
                            <span className="sub-header">
                              You have not recieved any new notification. Please
                              check back later
                            </span>
                            <span
                              className="showall"
                              onClick={this.handleClose}
                            >
                              <NavLink to="/notification_center">
                                Show all notifications
                              </NavLink>
                            </span>
                          </div>
                        </Paper>
                      )}
                    </>
                  )}
                </Popover>
              ) : null}

              <Avatar
                id="dropdownarrow"
                ref={(r) => {
                  this.avatarref = r;
                }}
                onClick={this.handleClick}
                src={getFormattedImageLink(
                  `${get(
                    this.props,
                    "AuthenticationAction.login.imagepath",
                    "",
                  )}`,
                )}
                alt="Employee"
                className="navigation-avatar cursour-pointer"
              />
              <span
                onClick={this.handleClick}
                aria-controls="simple-menu"
                aria-haspopup="true"
                className="dropdownarrow"
              >
                <ArrowDown />
              </span>
              <MenuList
                anchorEl={this.state.setAnchorEl}
                className="profile-menu"
                open={this.state.isexpand}
                onClose={this.handleClose}
              >
                <MenuItem className="navbar-profile-item">
                  <span className="menu-first-span">
                    <Avatar
                      src={getFormattedImageLink(
                        this.props.AuthenticationAction.login.imagepath,
                      )}
                      alt="Employee"
                    />
                  </span>
                  <span>
                    <span className="profile-heading">
                      {get(
                        this.props,
                        "AuthenticationAction.login.fullname",
                        "",
                      )}
                    </span>
                    <span className="profile-sub-heading">
                      {get(
                        this.props,
                        "AuthenticationAction.login.designationname",
                        "",
                      )}
                    </span>
                  </span>
                </MenuItem>
                {isAdmin &&
                  (this.props.selectionReducer.appMode != "config" ? (
                    <Link to="/config/dashboard" target="_blank">
                      <MenuItem
                        onClick={() =>
                          this.setState({
                            anchorEl: null,
                            isexpand: false,
                            menuopen: false,
                          })
                        }
                        className={"navbar-menu-config"}
                      >
                        <span className="menu-first-span">
                          <img className="menu-icon" src={ConfigModeIcon} />
                          Config Mode
                        </span>
                        <span className="sub-icon">
                          <img className="config-img" src={newTab} />
                        </span>
                      </MenuItem>
                    </Link>
                  ) : (
                    <Link to="/desk" target="_blank">
                      <MenuItem
                        onClick={() =>
                          this.setState({ anchorEl: null, isexpand: false })
                        }
                        className={"navbar-menu-config"}
                      >
                        <span className="menu-first-span">
                          <img className="menu-icon" src={ConfigModeIcon} />
                          Normal Mode
                        </span>
                        <span className="sub-icon">
                          <img className="config-img" src={newTab} />
                        </span>
                      </MenuItem>
                    </Link>
                  ))}
                {isAdmin && isOwner && (
                  <a
                    href={Configs.ACC_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <MenuItem
                      onClick={() =>
                        this.setState({ anchorEl: null, isexpand: false })
                      }
                      className={"navbar-menu-account"}
                    >
                      <span className="menu-first-span">
                        <img className="menu-icon" src={AccountSettingIcon} />
                        Account Settings
                      </span>
                      <span className="sub-icon" style={{ right: 4 }}>
                        <img className="config-img" src={newTab} />
                      </span>
                    </MenuItem>
                  </a>
                )}
                <NavLink to="/personal_privacy">
                  <MenuItem
                    onClick={() =>
                      this.setState({ anchorEl: null, isexpand: false })
                    }
                    className={"navbar-menu-items"}
                  >
                    <span className="menu-first-span">
                      <img className="menu-icon" src={ProfilePrivacyIcon} />
                      Profile Privacy
                    </span>
                  </MenuItem>
                </NavLink>

                <NavLink to="/change_password">
                  <MenuItem
                    onClick={() =>
                      this.setState({ anchorEl: null, isexpand: false })
                    }
                    className={"navbar-menu-items"}
                  >
                    <span className="menu-first-span">
                      <img className="menu-icon" src={ChangePasswordIcon} />
                      Change Password
                    </span>
                  </MenuItem>
                </NavLink>
                {
                  <NavLink to="/notification_preferences">
                    <MenuItem
                      onClick={() =>
                        this.setState({ anchorEl: null, isexpand: false })
                      }
                      className={"navbar-menu-items"}
                    >
                      <span className="menu-first-span">
                        <img
                          className="menu-icon"
                          src={NotificationSettingsIcon}
                        />
                        Notification Preferences
                      </span>
                    </MenuItem>
                  </NavLink>
                }

                <NavLink to="/help">
                  <MenuItem
                    onClick={() =>
                      this.setState({ anchorEl: null, isexpand: false })
                    }
                    className={"navbar-menu-items"}
                  >
                    <span className="menu-first-span">
                      <img className="menu-icon" src={HelpIcon} />
                      Help
                    </span>
                  </MenuItem>
                </NavLink>
                <NavLink to={window.location.pathname}>
                  <MenuItem
                    onClick={this.syncapp}
                    className={"navbar-menu-items"}
                  >
                    <span className="menu-first-span">
                      <img className="menu-icon" src={reload} />
                      Sync app ({ window.localStorage.getItem("appversion")})
                    </span>
                  </MenuItem>
                </NavLink>
                <MenuItem onClick={this.logout} className={"navbar-menu-items"}>
                  <span className="menu-first-span">
                    <img className="menu-icon" src={LogoutIcon} />
                    Logout
                  </span>
                </MenuItem>
              </MenuList>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

function Hit(props) {
  return (
    <div>
      <div className="search-list-item">
        <img
          src={props.hit.image ? props.hit.image : DefaultProfileImage}
          width="32"
          height="32"
          align="left"
        />
        <div className="margin-left-8">
          <p className="hit-name small-blue t-bold">
            <Highlight attribute="fullname" hit={props.hit} />
          </p>
          <p className="hit-designation extra-small-dark-secondary">
            {props.hit.designation ? props.hit.designation : "Designation"}
          </p>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  FCMReducer: state.FCMReducer,
  SetOpenLeftDrawer: state.selectionReducer.openLeftDrawer,
  isallappsopen: state.selectionReducer.isallappsopen,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LogMeOut,
      SetOpenLeftDrawer: (type, payload) => SetOpenLeftDrawer(type, payload),
      SetAllApps,
      PushNotificationActive,
      updateAuthentication,
      SetSelection: (d) => SetSelection(d),
      // updateAuthentication: data => updateAuthentication(data),
      // CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      // SetSelection: d => SetSelection(d),
      SetDrawerID: (dt) => SetDrawerID(dt),
      // updateSubscriptionInfo: (type, payload) => updateSubscriptionInfo(type, payload),
      // SetMenuList,
      // SetMenuData,
      // SetClickedBreadCrum,
      // SetOpenLeftDrawer
    },
    dispatch,
  );

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(CommonNavbar)),
);
